// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import type { Limits, CollapsibleButtonText } from '../types';
import media from '../../../helpers/media';
import type { ColorScheme } from '../../../types/theme';
import { Caret } from '../../button/button.styled';

export const isButtonVisible = (limits: Limits, count: number) => {
  if (typeof limits === 'number') {
    if (count <= limits) {
      return css`
        display: none;
      `;
    }
    return null;
  }

  return css`
    ${(count <= Number(limits.default)) && css`
      display: none;
    `}

    ${(count <= Number(limits.sm)) && media.sm(css`
      display: none;
    `)}

    ${(count <= Number(limits.md)) && media.md(css`
      display: none;
    `)}

    ${(count <= Number(limits.lg)) && media.lg(css`
      display: none;
    `)}

    ${(count <= Number(limits.xl)) && media.xl(css`
      display: none;
    `)}
  `;
};

type StyledButtonProps = {
  collapsed: boolean;
  limits: ?Limits,
  scheme: ColorScheme,
  nbItems: number,
  collapsible?: boolean;
};

type Props = StyledButtonProps & {
  minimalistic?: boolean,
  onClick: Function,
  collapsed: boolean,
  buttonText: CollapsibleButtonText,
};

const caretUp = 'rotateZ(135deg) translate(-4px, -4px)';
const caretDown = 'rotateZ(315deg) translate(6px, 2px)';

const StyledButton = styled<any, Theme, StyledButtonProps>('button')`
  background: transparent;
  border: none;
  color: ${({ scheme }) => scheme.anchor};
  cursor: pointer;
  font-size: ${({ theme }) => theme.list.fontSize};
  padding: 0 1rem 0 0;
  ${Caret}
  &:after {
    transform: ${({ collapsed }) => (collapsed ? caretDown : caretUp)};
  }

  ${props => (props.collapsible ? isButtonVisible(props.limits || 0, props.nbItems) : null)}
`;

const CollapseButton = ({
  scheme,
  buttonText,
  collapsed,
  collapsible,
  limits,
  nbItems,
  onClick,
  minimalistic,
}: Props) => (
  <StyledButton
    scheme={scheme}
    collapsed={collapsed}
    minimalistic={minimalistic}
    limits={limits}
    nbItems={nbItems}
    onClick={onClick}
    collapsible={collapsible}
    buttonText={buttonText}
  >
    {collapsed ? buttonText.collapsed : buttonText.expanded}
  </StyledButton>
);

CollapseButton.defaultProps = {
  minimalistic: false,
  collapsible: false,
};

export default CollapseButton;
